const surface = require("./surface-colors");

const theme = {
	colors: {
		primary: "#1F7CDE",
		"primary-content": "#FFFFFF",
		secondary: "#79CBF4",
		"secondary-content": "#FFFFFF",
		accent: "#E83181",
		"accent-content": "#FFFFFF",
		neutral: "#394B63",
		"neutral-content": "#FFFFFF",
		info: "#0284C7",
		"info-content": "#FFFFFF",
		success: "#18967D",
		"success-content": "#FFFFFF",
		warning: "#F99500",
		"warning-content": "#FFFFFF",
		error: "#E53355",
		"error-content": "#FFFFFF",
		"base-100": surface.DEFAULT,
		"base-200": surface.muted,
		"base-300": surface.strong,
		"base-content": "#27272A",
	},
	surface,
	screens: {
		// Real external monitors: sidebar stays permanently expanded (fixed).
		// Below this, incl. 14-16" MacBooks (~1512-1792px), sidebar slides out on hover.
		monitor: "1800px",
		desktop: "1280px",
		laptop: "1024px",
		mobile: "600px",
	},
	fontFamily: {
		sans: ["Inter", "sans-serif"],
		serif: ["Inter", "serif"],
	},
};

module.exports = theme;
